export default __webpack_public_path__ + "static/media/new_paper_analysis_fonts.1198faf7.png";